<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-8">
        <h1>{{title}}</h1>
      </div>
      <div class="col-12 col-sm-4 mb-2">
        <button class="btn btn-sm btn-success float-right" (click)="addGeofenceDialog()"><i class="fas fa-plus mr-1"></i> Add
          Geofence</button>
      </div>
      <div class="col-12">
        <div class=" ">
          <input type="text" class="form-control form-control-sm input-custom" (keyup)="applyFilter($event)"
            placeholder="Search" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <div class="table-responsive db-block" style="height: auto !important;">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{title}}</span>

          <a type="button" class="float-right mr-4" (click)="importGeofenceCSV()">
            <i class="fa fa-upload mr-1" aria-hidden="true"></i> Import Geofence
          </a>

          <a type="button" class="float-right mr-4" (click)="importGeofenceDetailsCSV()">
            <i class="fa fa-upload mr-1" aria-hidden="true"></i> Import Geofence Details
          </a>

          <!-- <a type="button" class="float-right mr-4" (click)="sampleCSV()">
            <i class="fas fa-download mr-1" aria-hidden="true"></i> Sample CSV
          </a> -->

          <a type="button" class="float-right mr-4" (click)="exportGeofenceCSV()">
            <i class="fa fa-cloud-download-alt mr-1" aria-hidden="true"></i> Export Geofence
          </a>

          <a type="button" class="float-right mr-4" (click)="exportGeofenceDetailsCSV()">
            <i class="fa fa-cloud-download-alt mr-1" aria-hidden="true"></i> Export Geofence Details
          </a>

          <br>

          <a type="button" class="float-right mr-4" (click)="sampleGeofenceCSV()">
            <i class="fas fa-download mr-1" aria-hidden="true"></i> Sample Geofence CSV
          </a>

          <a type="button" class="float-right mr-4" (click)="sampleGeofenceDetailsCSV()">
            <i class="fas fa-download mr-1" aria-hidden="true"></i> Sample Geofence Details CSV
          </a>
          
        <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
          <ng-container matColumnDef="geofenceId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Geofence ID</th>
            <td mat-cell *matCellDef="let element"> {{element.geofenceId}} </td>
          </ng-container>
  
          <ng-container matColumnDef="geofenceName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Geofence Name</th>
            <td mat-cell *matCellDef="let element"> {{element.geofenceName}} </td>
          </ng-container>
  
          <ng-container matColumnDef="geofenceDesc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Geofence Description</th>
            <td mat-cell *matCellDef="let element"> {{element.geofenceDesc}} </td>
          </ng-container>
  
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"> 
              <span *ngIf="element.status == 1; else inactive">Active</span>
              <ng-template #inactive><span>InActive</span></ng-template>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="geofenceMap">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Geofence Map</th>
            <td mat-cell *matCellDef="let element">
              <button class="btn btn-sm btn-success" (click)="openMap(element)"><i class="fas fa-plus-circle"></i> Interactive Geofence</button>  
            </td>
          </ng-container>

          <ng-container matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
            <td mat-cell *matCellDef="let element">
              <button class="btn btn-sm btn-success" (click)="viewZoneDialog(element)"><i class="fas fa-eye"></i> View Zone</button>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
  
              <button mat-icon-button matTooltip="Click to Edit" (click)="updateGeofenceDialog(element)" class="iconbutton text-warning float-left">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>

              <button mat-icon-button  matTooltip="Click to Delete" (click)="getTempId(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePromptU">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button> 
              
              <div class="modal fade" id="deletePromptU" tabindex="-2" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title orange-text" id="deletePromptLabel">Delete Geofence </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      </div>
                      <div class="modal-body">
                        Are you sure you want to delete this geofence?
                      </div>
                      <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                      <button type="button" class="btn btn-danger" (click)="deleteGeofence(tempId)" data-dismiss="modal">Confirm</button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>

